import { stringifyValues } from '@atc/string-fns';
import cloneDeep from 'lodash/cloneDeep';
const labelLookUpTable = {
  dealType: 'priceRating',
  dealTypes: 'priceRating',
  doorCode: 'doors',
  doorCodes: 'doors',
  driveGroup: 'driveType',
  endYear: 'yearMax',
  // engineCodes: 'cylinders',
  extColorSimple: 'exteriorColor',
  extColorsSimple: 'exteriorColor',
  featureCode: 'features',
  featureCodes: 'features',
  fuelTypeGroup: 'fuelType',
  // homeServices: 'dealer-home-services',
  intColorSimple: 'interiorColor',
  interiorColorsSimple: 'interiorColor',
  keywordPhrases: 'keywords',
  listingType: 'vehicleCondition',
  listingTypes: 'vehicleCondition',
  makeCode: 'makeName',
  makeCodeList: 'makeName',
  maxMileage: 'mileage',
  maxPrice: 'priceMax',
  mileage: 'mileage',
  minPrice: 'priceMin',
  modelCode: 'modelName',
  modelCodeList: 'modelName',
  mpgRange: 'fuelEconomy',
  mpgRanges: 'fuelEconomy',
  productTypes: 'productType',
  searchRadius: 'radius',
  sellerType: 'sellerType',
  sellerTypes: 'sellerType',
  seriesCode: 'seriesName',
  seriesCodeList: 'seriesName',
  startYear: 'yearMin',
  transmissionCodes: 'transmission',
  trimCode: 'trimName',
  trimCodeList: 'trimName',
  vehicleStyleCode: 'bodyStyle',
  vehicleStyleCodes: 'bodyStyle',
  vehicleHistoryType: 'vehicleHistory',
  vhrTypes: 'vehicleHistory',
  zip: 'zipCode'
};
const translateSellerTypeValue = function (data) {
  if (data === void 0) {
    data = [];
  }
  let filtersData = data;
  if (data && !Array.isArray(data)) {
    filtersData = [data];
  }
  filtersData.forEach((item, i) => {
    if (filtersData[i] === 'p') {
      filtersData[i] = 'private-seller';
    }
    if (filtersData[i] === 'd') {
      filtersData[i] = 'dealer';
    }
  });
  return filtersData;
};
const pageDataTransformer = function (filters) {
  if (filters === void 0) {
    filters = {};
  }
  const filtersCopy = cloneDeep(filters);
  return Object.keys(filtersCopy).reduce((acc, key) => {
    if (labelLookUpTable[key]) {
      if (['searchRadius', 'maxMileage'].indexOf(key) > -1) {
        // covert searchRadius and maxMileage to match dataLayer on other apps
        acc[labelLookUpTable[key]] = stringifyValues(filtersCopy[key].toString());
      } else if (['sellerType', 'sellerTypes'].indexOf(key) > -1) {
        acc[labelLookUpTable[key]] = translateSellerTypeValue(filtersCopy[key]);
      } else if (['trimCodeList'].indexOf(key) > -1) {
        // Convert from MODEL|TRIM to only TRIM
        acc[labelLookUpTable[key]] = filtersCopy[key].map(trim => trim.split('|')[1]);
      } else {
        acc[labelLookUpTable[key]] = !Array.isArray(filtersCopy[key]) ? filtersCopy[key]?.toString() : filtersCopy[key];
      }
    }
    return acc;
  }, {});
};
export default pageDataTransformer;